import { render, staticRenderFns } from "./FriendEntry.vue?vue&type=template&id=f3169246&scoped=true&"
import script from "./FriendEntry.vue?vue&type=script&lang=js&"
export * from "./FriendEntry.vue?vue&type=script&lang=js&"
import style0 from "./FriendEntry.vue?vue&type=style&index=0&id=f3169246&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3169246",
  null
  
)

export default component.exports